import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    coverageAddress: undefined,
    customer: undefined,
    registry: undefined,
    product: undefined,
    paymentData: undefined,
    chosenPaymentMethod: undefined,
    policies: undefined
};
export default createSlice({
    name: 'connectivity',
    initialState: initialState,
    reducers: {
        updateConnectivityData: (state, action) => {
            let paymentData = action.payload.paymentData;
            state.coverageAddress = action.payload.coverageAddress;
            state.customer = action.payload.customer;
            state.registry = action.payload.registry;
            state.product = action.payload.product;
            state.paymentData = paymentData;
            if (paymentData && paymentData.paymentMethod) {
                state.chosenPaymentMethod = paymentData.paymentMethod;
            }
            state.policies = action.payload.policies;
        },
        updateRegistry: (state, action) => {
            state.registry = action.payload;
        },
        updatePaymentMethod: (state, action) => {
            state.chosenPaymentMethod = action.payload;
        },
        updatePaymentData: (state, action) => {
            state.paymentData.paymentMethod = action.payload.paymentMethod;
            state.paymentData.iban = action.payload.iban;
        }
    },
});
